import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { FiscalYear } from './fiscalYear.model';

const axios = useAxios();

export interface FiscalYearService {
  Fetch: () => Promise<AxiosResponse<FiscalYear[]>>;
}

const Fetch = (): Promise<AxiosResponse<FiscalYear[]>> =>
  axios.Get<FiscalYear[]>('/api/fiscalyears');

export default { Fetch } as FiscalYearService;
